// extracted by mini-css-extract-plugin
export default {"wrapper":"tB-z","viewport":"uB-z","container":"vB-z","slide":"wB-z"};